import React from 'react';
import { Link } from 'react-router-dom';

export default function PricingPage() {
  const plans = [
    {
      name: 'Free',
      price: '£0',
      period: 'forever',
      features: [
        'Take personality test',
        'Receive personality evaluation',
        'Browse potential matches',
        'Access travel warnings & info',
        'View trending travel locations',
        'Basic AI companion support',
        'Limited messaging (3/day)',
        'View member profiles'
      ],
      popular: false,
      cta: 'Current Plan',
      disabled: true
    },
    {
      name: 'Premium',
      price: '£8.99',
      period: 'per month',
      features: [
        'Everything in Free',
        'Unlimited messaging',
        'Search & filter members',
        'Organize local meets',
        'Join travel groups',
        'Priority support',
        'Advanced matching',
        'Travel deals access',
        'Friendly AI companion',
        'Mobile app access'
      ],
      popular: true,
      cta: 'Start Free Trial',
      disabled: false
    },
    {
      name: 'Annual',
      price: '£99',
      period: 'per year',
      features: [
        'Everything in Premium',
        '2 months free',
        'Exclusive travel events',
        'VIP support',
        'Early access to features',
        'Custom travel planning'
      ],
      popular: false,
      cta: 'Save 17%',
      disabled: false
    }
  ];

  return (
    <div className="container" style={{ padding: 'var(--spacing-8) 0' }}>
      <div className="row justify-center">
        <div className="col col--10">
          <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-8)' }}>
            <h1 style={{ marginBottom: 'var(--spacing-3)' }}>Choose Your Plan</h1>
            <p style={{ fontSize: '1.2em', color: 'var(--gray-600)', maxWidth: '600px', margin: '0 auto' }}>
              Start with our free plan and upgrade when you're ready to unlock all features
            </p>
          </div>

          <div className="row" style={{ gap: 'var(--spacing-4)' }}>
            {plans.map((plan, index) => (
              <div key={index} className="col col--4" style={{ 
                display: 'flex',
                flexDirection: 'column'
              }}>
                <div className="card p-6" style={{
                  height: '100%',
                  position: 'relative',
                  border: plan.popular ? '3px solid var(--primary-blue)' : '1px solid var(--gray-200)',
                  transform: plan.popular ? 'scale(1.05)' : 'none',
                  zIndex: plan.popular ? 1 : 0
                }}>
                  {plan.popular && (
                    <div style={{
                      position: 'absolute',
                      top: '-12px',
                      left: '50%',
                      transform: 'translateX(-50%)',
                      background: 'var(--primary-blue)',
                      color: 'white',
                      padding: 'var(--spacing-1) var(--spacing-3)',
                      borderRadius: 'var(--radius-sm)',
                      fontSize: 'var(--font-size-sm)',
                      fontWeight: 'bold'
                    }}>
                      MOST POPULAR
                    </div>
                  )}

                  <div style={{ textAlign: 'center', marginBottom: 'var(--spacing-6)' }}>
                    <h2 style={{ marginBottom: 'var(--spacing-2)' }}>{plan.name}</h2>
                    <div style={{ marginBottom: 'var(--spacing-2)' }}>
                      <span style={{ fontSize: '2.5em', fontWeight: 'bold' }}>{plan.price}</span>
                      <span style={{ color: 'var(--gray-600)' }}>/{plan.period}</span>
                    </div>
                    {plan.name === 'Annual' && (
                      <p style={{ color: 'var(--success-green)', fontWeight: 'bold', margin: 0 }}>
                        Save £19.88/year
                      </p>
                    )}
                  </div>

                  <ul style={{ 
                    listStyle: 'none', 
                    padding: 0, 
                    margin: 0,
                    flex: 1
                  }}>
                    {plan.features.map((feature, featureIndex) => (
                      <li key={featureIndex} style={{ 
                        marginBottom: 'var(--spacing-3)',
                        paddingLeft: 'var(--spacing-4)',
                        position: 'relative'
                      }}>
                        <span style={{ 
                          position: 'absolute', 
                          left: 0, 
                          top: '2px',
                          color: 'var(--success-green)'
                        }}>✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <div style={{ marginTop: 'var(--spacing-6)', textAlign: 'center' }}>
                    {plan.disabled ? (
                      <button className="btn btn--secondary" disabled style={{
                        width: '100%',
                        opacity: 0.6
                      }}>
                        {plan.cta}
                      </button>
                    ) : (
                      <Link to="/payment" className="btn btn--primary" style={{
                        width: '100%',
                        textDecoration: 'none'
                      }}>
                        {plan.cta}
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ 
            marginTop: 'var(--spacing-8)', 
            textAlign: 'center',
            padding: 'var(--spacing-6)',
            background: 'var(--gray-50)',
            borderRadius: 'var(--radius-lg)'
          }}>
            <h3 style={{ marginBottom: 'var(--spacing-4)' }}>Frequently Asked Questions</h3>
            
            <div className="row" style={{ gap: 'var(--spacing-4)' }}>
              <div className="col col--6">
                <h4>Can I cancel anytime?</h4>
                <p>Yes! You can cancel your subscription at any time. You'll continue to have access until the end of your billing period.</p>
              </div>
              <div className="col col--6">
                <h4>Is there a free trial?</h4>
                <p>Yes! Premium plans come with a 7-day free trial. No credit card required to start.</p>
              </div>
              <div className="col col--6">
                <h4>What payment methods do you accept?</h4>
                <p>We accept all major credit cards, debit cards, and PayPal. All payments are processed securely through Stripe.</p>
              </div>
              <div className="col col--6">
                <h4>Can I upgrade or downgrade?</h4>
                <p>Absolutely! You can change your plan at any time. Changes take effect immediately.</p>
              </div>
            </div>
          </div>

          <div style={{ 
            marginTop: 'var(--spacing-6)', 
            textAlign: 'center',
            padding: 'var(--spacing-4)',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: 'var(--radius-lg)',
            color: 'white'
          }}>
            <h3 style={{ marginBottom: 'var(--spacing-3)' }}>Ready to Find Your Perfect Travel Companion?</h3>
            <p style={{ marginBottom: 'var(--spacing-4)', opacity: 0.9 }}>
              Join thousands of travelers who have found their ideal travel partners through GradedWash
            </p>
            <Link to="/payment" className="btn btn--primary btn--large" style={{
              background: '#4ade80',
              border: 'none',
              color: 'white',
              padding: 'var(--spacing-3) var(--spacing-6)',
              textDecoration: 'none',
              fontWeight: 'bold'
            }}>
              Start Your Free Trial
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
} 